import { useState } from 'react';
import cx from 'classnames';
import { useTranslations } from 'next-intl';
import CommonInput from '@/components/CommonInput/mIndex';
import Toast from '@/components/Toast';
import { checkOutSideVideo, CheckOutSideVideoStatus } from '@/api/video/parse';
import Styles from './mIndex.module.scss';

export interface ILinkModal {
  textId: string;
  onCancel: () => void;
  onChange: (textId: string, linkUrl: string, linkTitle: string) => void;
}

const LinkModal = ({
  textId,
  onCancel,
  onChange,
}: ILinkModal) => {
  const [linkUrl, setLinkUrl] = useState('');
  const t = useTranslations();

  const handleCancel = () => {
    onCancel();
  };

  const handleSubmit = async () => {
    const data = await checkOutSideVideo({ url: linkUrl });
    if (data?.status !== CheckOutSideVideoStatus.success) {
      Toast.show({
        content: t('error_link_url'),
      })
      return;
    }

    onChange(textId, data?.url || '', data?.title || '');
  };

  const handleChange = (val: string = '') => {
    setLinkUrl(val);
  };

  return (
    <div className={Styles.root}>
      <div className={Styles.wrapper}>
        <div className={Styles.header}>
          <div className={Styles.cancel} onClick={handleCancel} />
          <div className={Styles.title}>{t('thread_add_link')}</div>
          <div
            className={cx(Styles.submit, { [Styles.disabled]: !linkUrl })}
            onClick={!!linkUrl ? handleSubmit : undefined}
          >
            {t('btn_add')}
          </div>
        </div>
        <div className={Styles.hintsWrapper}>
          <div className={Styles.hints}>{t('tips_thread_link')}</div>
        </div>
        <div className={Styles.input}>
          <CommonInput enableClear onChange={handleChange} />
        </div>
      </div>
    </div>
  );
};

export default LinkModal;
